<template>
  <div>
    <div class="filter-item-select">
      <label class="select-filter-options">
        <select ref="filterList" v-model="selected">
          <option
            v-for="(item, index) in filterItem.filter_item_list"
            :key="filterTitle + index"
          >
            {{ item.title }}
          </option>
        </select>
      </label>
      <span class="filter-button">
        <OpenIcon />
      </span>
    </div>
  </div>
</template>

<script>
  import OpenIcon from '@/assets/svg/common/ic_open_w.svg'
  import { mapMutations } from 'vuex'
  import utils from '@/common/util/utils'
  import {
    ALREADY_ADULT_VERIFIED,
    HIDDEN_CONTENT_REDIRECT_TO_HOME,
    NEED_LOGIN,
    NEED_PIN_CODE,
    NEED_VERIFIED,
    NOT_A_ADULT_CONTENT,
  } from '@/common/constant'
  import { get } from 'lodash'
  import { parseUrl, stringify } from 'query-string'
  import { verifyAdultContentProtectionState } from '@/common/api/api.service'
  import {
    PATH_NAME_ADULTVERIFY,
    PATH_NAME_ADULTVERIFY_UNLOCK,
    PATH_NAME_LIST,
  } from '@/common/router.const'
  import { sendEventLogSearchFilterChange } from '@/common/util/log.v2.send'

  export default {
    name: 'FilterListForDevice',
    components: {
      OpenIcon,
    },
    props: {
      filterTitle: {
        type: String,
      },
      filterItem: {
        type: Object,
      },
      filterIndex: {
        type: Number,
      },
    },
    data() {
      return {
        selected: this.filterTitle,
      }
    },
    methods: {
      ...mapMutations(['showAdultCheck', 'hideAdultCheck', 'showLoginView']),
      selectFilterItem(item) {
        const emitSetFilterQuery = (filterItem) => {
          // eslint-disable-next-line camelcase
          const { api_parameters: apiParameters, title } = filterItem

          sendEventLogSearchFilterChange({
            current: this.$route.name,
            contentType: `${this.$route.query.searchCategory || ''}${this.$route.query.mType || ''}`,
            selectedFilter: apiParameters.replace('&orderby=', ''),
          })
          this.$emit('set-filter-query', {
            queryString: apiParameters,
            selectedTitle: title,
            filterIndex: this.filterIndex,
          })
        }
        emitSetFilterQuery(item)
      },
    },
    watch: {
      async selected(newVal, oldVal) {
        const getFilterItemByValue = (value) => {
          return this.filterItem.filter_item_list.filter((item, index) => {
            return item.title === value
          })[0]
        }
        if (newVal !== oldVal) {
          this.$refs.filterList.blur()
          const newFilterItem = getFilterItemByValue(newVal)
          const oldFilterItem = getFilterItemByValue(oldVal)
          if (newFilterItem.adult === 'y') {
            const res = await utils.common.verifyAdult(19)
            const api = get(this.$route, 'query.api', '')
            const currentApi = parseUrl(api)
            const [queryKey, queryValue] = newFilterItem.api_parameters
              .replace('&', '')
              .split('=')
            const newApiQuery = Object.assign({}, currentApi.query, {
              [queryKey]: queryValue,
            })
            switch (res) {
              case NOT_A_ADULT_CONTENT:
              case ALREADY_ADULT_VERIFIED:
                this.selectFilterItem(newFilterItem)
                break
              case HIDDEN_CONTENT_REDIRECT_TO_HOME:
                this.$router.replace('/')
                break
              case NEED_LOGIN:
                this.selected = oldFilterItem.title
                this.$router.push('/login')
                break
              case NEED_PIN_CODE:
                this.$router.replace({
                  name: PATH_NAME_ADULTVERIFY_UNLOCK,
                  query: {
                    referer: this.$route.fullPath,
                  },
                  params: {
                    action: async ({ pincode, resetFn, successFn }) => {
                      try {
                        const result =
                          await verifyAdultContentProtectionState(pincode)
                        const { resultcode } = result.data
                        if (resultcode === '200') {
                          successFn()
                          this.selectFilterItem(newFilterItem)
                        }
                      } catch (e) {
                        if (typeof resetFn === 'function') {
                          resetFn()
                        }
                      }
                    },
                    enter: {
                      name: PATH_NAME_LIST,
                      params: {
                        uiCode:
                          this.$route.params.uiCode ||
                          this.$route.params.section,
                        queryString: newFilterItem.api_parameters,
                        selectedTitle: newFilterItem.title,
                        filterIndex: this.filterIndex,
                      },
                      query: {
                        api: `${currentApi.url}?${stringify(newApiQuery)}`,
                      },
                    },
                  },
                })
                break
              case NEED_VERIFIED:
                this.selected = oldFilterItem.title
                this.$router.push({
                  name: PATH_NAME_ADULTVERIFY,
                  params: {
                    referer: {
                      name: PATH_NAME_LIST,
                      params: {
                        uiCode:
                          this.$route.params.uiCode ||
                          this.$route.params.section,
                        queryString: newFilterItem.api_parameters,
                        selectedTitle: newFilterItem.title,
                        filterIndex: this.filterIndex,
                      },
                      query: {
                        api: `${currentApi.url}?${stringify(newApiQuery)}`,
                      },
                    },
                  },
                })
                break
            }
          } else {
            this.selectFilterItem(newFilterItem)
          }
        }
      },
    },
    created() {
      if (
        get(this.$route, ['params', 'selectedTitle'], '') !== '' &&
        this.filterIndex === get(this.$route, ['params', 'filterIndex'], '')
      ) {
        this.selected = get(this.$route, ['params', 'selectedTitle'], '')
      }

      this.$emit('set-filter-query', {
        queryString: get(this.$route, 'params.queryString', ''),
        selectedTitle: get(this.$route, 'params.selectedTitle', ''),
        filterIndex: get(this.$route, 'params.filterIndex', 0),
      })
    },
  }
</script>

<style scoped>
  .filter-item-select select {
    -webkit-appearance: none; /* 네이티브 외형 감추기 */
    -moz-appearance: none;
    appearance: none;
    border: none;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    text-align-last: right;
    direction: rtl;
    color: #fff;
    background-color: #1b1b1b;
  }

  .play-menu-container .filter-item-select select {
    color: #a5a5a5;
  }

  .filter-item-select select:focus {
    outline: none;
  }

  .filter-item-select option {
    direction: ltr;
  }

  @media screen and (max-width: 380px) {
    /*.filter-item-select select {*/
    /*  font-size: 12px;*/
    /*}*/
  }

  .filter-button {
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }

  .filter-button svg {
    display: block;
  }
</style>
